// extracted by mini-css-extract-plugin
export default {"wrapper":"AuthSwitchLink_wrapper__Q+b6h","link":"AuthSwitchLink_link__SrvAw"};